<template>
  <!-- 地区维护 -->
  <div>
    <div class="box">
      <!-- 左边 -->
      <div class="boxleft glo_Table">
        <el-table
          ref="leftTable"
          :data="menuTableData"
          style="width: 100%"
          row-key="districtId"
          border
          :height="leftHeight"
          lazy
          :load="loadMore"
          @row-click="rowClickLeft"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <el-table-column
            prop="districtName"
            label="地区"
            sortable
            width="200"
          ></el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small">
                <span
                  v-if="hasPermiss('aaaaa')"
                  class="tablebut"
                  @click.stop="menuadd(scope.row)"
                  >添加</span
                >
                <span
                  v-if="hasPermiss('aaaaa')"
                  class="tablebut"
                  @click.stop="menumodify(scope.row, 'left')"
                  >修改</span
                >
                <span
                  v-if="hasPermiss('aaaaa')"
                  class="tablebut"
                  @click.stop="delBtns(scope.row.districtId, 'left')"
                  >删除</span
                >
                <!-- <span
                  v-if="hasPermiss('aaaaa')"
                  class="tablebut"
                  @click="jinYong(scope.row.districtId)"
                  >禁用</span
                >
                <span
                  v-if="scope.row.isDisable == 1 && hasPermiss('aaaaa')"
                  class="tablebut"
                  style="color: #999"
                  @click="qiYong(scope.row.districtId)"
                  >启用</span
                >-->
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 右边 -->
      <div class="boxright">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList">
          <div class="glo_btnList_left">
            <el-button
              v-if="hasPermiss('aaaaa')"
              class="glo_btnItems glo_bgcMainColor"
              @click="menuadd()"
              >新增</el-button
            >

            <el-button class="glo_btnItems" @click="qiYongMore"
              >批量启用</el-button
            >
            <el-button class="glo_btnItems" @click="jinYongMore"
              >批量禁用</el-button
            >
            <el-button class="glo_btnItems" @click="DaochuMore">导出</el-button>
            <!-- <el-button class="glo_btnItems" @click="delBtnsMore">删除</el-button> -->
          </div>

          <queryBtns
            :MoreConditions="MoreConditions"
            :showMoreBtns="false"
            @clerBtns="clerBtns"
            @queryBtn_ok="queryBtn_ok"
            @moreParam="moreParam"
          ></queryBtns>
        </div>
        <!-- 查询条件 -->
        <div ref="queryForm">
          <el-form
            :model="queryData"
            :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
            label-position="left"
          >
            <el-form-item class="queryItems" label="上级地区:">
              <el-select
                v-model="queryData.parentName"
                clearable
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="remoteMethod"
                :loading="false"
                @change="changeParentAddress"
              >
                <el-option
                  v-for="(item, index) in SuperiorRegionList"
                  :key="index"
                  :label="item.districtName"
                  :value="item.districtName"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item class="queryItems" label="地区名称:">
              <el-input
                clearable
                v-model="queryData.districtName"
                placeholder="请输入"
                @keyup.enter.native="queryBtn_ok"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>

        <!-- 表格 -->
        <div class="glo_Table" ref="tableWrapper">
          <el-table
            :height="tableHeigth"
            ref="mytable"
            @row-click="rowclick"
            :data="tableData"
            stripe
            border
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              fixed="left"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column
              fixed="left"
              type="selection"
              width="60"
            ></el-table-column>
            <template v-for="(item, index) in myTableHeard">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                sortable
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item.field == 'isEnableShow'"
              >
                <template slot-scope="scope">
                  <div style="color: #f00" v-if="scope.row.isEnable == '0'">
                    禁用
                  </div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                sortable
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-else-if="item && item.isShow"
              ></el-table-column>
            </template>
            <el-table-column fixed="right" label="操作" min-width="220px">
              <template slot-scope="scope">
                <div class="tabRightBtns">
                  <el-button
                    class="rbtns"
                    @click.stop="menumodify(scope.row, 'right')"
                    >编辑</el-button
                  >
                  <el-button
                    class="rbtns"
                    @click.stop="qiYong(scope.row.districtId)"
                    >启用</el-button
                  >
                  <el-button
                    class="rbtns"
                    @click.stop="jinYong(scope.row.districtId)"
                    >禁用</el-button
                  >
                  <el-button
                    class="rbtns"
                    @click.stop="delBtns(scope.row.districtId, 'right')"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页组件 -->
        <paging
          ref="pags"
          :pageNum="pageStart"
          :total="total"
          :sizeList="sizeList"
          :size="pageTotal"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>

    <!-- 弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="PopUpTitle"
      :isShowDialog="menushowBOX"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn('CalculationRulesRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="menushowBOX"
          ref="CalculationRulesRef"
          :model="CalculationRules"
          label-width="100px"
          :rules="rules"
        >
          <el-form-item
            class="dialogFormItems"
            prop="districtName"
            label="地区名称:"
          >
            <el-input
              placeholder="请输入"
              clearable
              v-model="CalculationRules.districtName"
            ></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="adcode" label="地址编码:">
            <el-input
              placeholder="请输入"
              clearable
              v-model="CalculationRules.adcode"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="parentId"
            label="上级地区:"
          >
            <el-select
              v-model="CalculationRules.parentId"
              clearable
              placeholder="请输入关键词"
              filterable
              remote
              :loading="false"
              :remote-method="remoteMethod2"
            >
              <el-option
                v-for="(item, index) in SuperiorRegionList2"
                :key="index"
                :label="item.districtName"
                :value="item.districtId"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item class="dialogFormItems" prop="aaa" label="编号:">
            <el-input
              placeholder="自动生成"
              v-model="CalculationRules.aaa"
              disabled
            ></el-input>
          </el-form-item>-->
          <el-form-item
            class="dialogFormItems"
            prop="isEnable"
            label="是否启用:"
          >
            <el-select
              clearable
              filterable
              v-model="CalculationRules.isEnable"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in isEnableList"
                :key="index"
                :label="item.name"
                :value="item.val + ''"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="sort" label="排序:">
            <el-input
              placeholder="请输入"
              v-model="CalculationRules.sort"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="CalculationRules.remarks"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 当前页面的查询条件 -->
      <div ref="queryForm">
        <el-form
          :model="queryData"
          class="glo_form hasMoreParam"
          label-position="left"
        >
          <el-form-item class="queryItems" label="上级地区:">
            <el-select
              v-model="queryData.parentName"
              clearable
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="false"
              @change="changeParentAddress"
            >
              <el-option
                v-for="(item, index) in SuperiorRegionList"
                :key="index"
                :label="item.districtName"
                :value="item.districtName"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="queryItems" label="地区名称:">
            <el-input
              clearable
              v-model="queryData.districtName"
              placeholder="请输入"
              @keyup.enter.native="queryBtn_ok"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </exportCompoent>
  </div>
</template>

<script>
import paging from "@/components/pagings.vue";
import queryBtns from "@/components/queryBtns.vue";
import myDialog from "@/components/Dialog.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [exportjs],
  inject: ["reload"],
  components: {
    paging,
    queryBtns,
    myDialog,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "地区维护", //导出时默认文件名
        apiName: "/admin/v3/tms/district/getDistrictList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      CalculationRules: {
        districtName: "",
        adcode: "",
        parentId: "", //
        isEnable: "0", //
        sort: "1", //菜单排序
        remarks: "", //
        loading: false,
      },
      rules: {
        districtName: [{ required: true, message: "请输入", trigger: "blur" }],
        // adcode: [{ required: true, message: "请输入", trigger: "blur" }],
        parentId: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      PopUpTitle: "", //弹窗标题
      menushowBOX: false, //菜单弹窗
      menuTableData: [],
      diaWidth: "40%",
      //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

      queryData: {
        districtName: "",
        parentName: "",
        parentId: "",
      },

      // ================
      pageStart: 1, //页码
      total: 0, //总条数
      sizeList: [10, 20, 50, 100, 200],
      pageTotal: this.$COMMON.pageTotals, //一页几条
      nextPage: false, //是否有下一页
      show_sortTableHeard: false, //显示弹窗
      show_upload: false, //显示上传弹窗
      myTableHeard: [], //我的表头
      originalTabelHeadeTitle: [],
      selectLength: 0, //显示的长度
      allCheck: false, //全选
      leftHeight: "50vh",
      tableHeigth: "50vh",
      tabelHeadeTitle: [
        {
          name: "编号",
          field: "adcode",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "120",
        },
        {
          name: "地区名称",
          field: "districtName",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "120",
        },
        {
          name: "上级地区",
          field: "parentName",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "120",
        },
        {
          name: "是否启用",
          field: "isEnableShow",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "120",
        },
        {
          name: "排序",
          field: "sort",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "160",
        },
        {
          name: "备注",
          field: "remarks",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "160",
        },
        {
          name: "新建时间",
          field: "updateTime",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "160",
        },
        {
          name: "创建人",
          field: "createName",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "120",
        },
        {
          name: "修改时间",
          field: "updateTime",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "160",
        },
        {
          name: "修改人",
          field: "updateName",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "120",
        },
      ],
      tableData: [],
      totalArr: [], //需要合计的字段
      className: "", //导出需要
      fieldName: [], //下载字段名
      head: [], //下载表头字段
      fileList: [],
      sortName: "地区维护", //排序名
      pageGroupName: "RegionalMaintenance", //页面标识
      selectTableData: [], //选中的数据

      deperIds: [],
      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      SuperiorRegionList: [], //上级地区
      SuperiorRegionList2: [], //上级地区(弹窗的)
      dialogType: "", //add==新建  edit==编辑
      ClickLR: "", //left==左边列表的编辑 right==右边列表的编辑
      isEnableList: [
        {
          name: "启用",
          val: "1",
        },
        {
          name: "禁用",
          val: "0",
        },
      ],
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    if (this.originalTabelHeadeTitle.length == 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      );
    }
    this.myTableHeard = this.tabelHeadeTitle;
    // this.getGroupFindFieldSort(); //获取用户自定义表头

    this.endtime = this.$TOOLS.getCurrentDate(); //今天的时间;
    this.sarttime = this.$TOOLS.getFlexDate(-3); //三天前
    this.times = [this.sarttime, this.endtime];
    this.getData();
    this.departmentHierarchy("-1");
    this.getParentName("中华人民共和国"); //默认查到各省
  },
  mounted() {
    const that = this;
  },
  activated() {
    this.$nextTick(() => {
      this.fetTableHeight();
    });
  },
  watch: {},
  methods: {
    DaochuMore() {
      this.isShowDialog_dc = true;
    },
    // 获取数据
    getData() {
      let param = {
        districtName: this.queryData.districtName,
        parentName: this.queryData.parentName,
        parentId: this.queryData.parentId,
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
      };
      this.$API.wtl_getDistrictList(param).then((res) => {
        //console.log(res.data.result.data);
        if (res.data.status == "success") {
          this.className = res.data.result.className || "";
          this.tableData = res.data.result.data || [];
          this.total = res.data.result.pageCount || 0;
          this.fetTableHeight();
        }
      });
    },
    // 查询按钮
    queryBtn_ok() {
      this.pageStart = 1;
      this.getData();
    },
    // 重置按钮
    queryBtn_cz() {
      this.queryData = {
        districtName: "",
        parentName: "",
        parentId: "",
      };
    },
    // 查询条件上级地区发生变化时
    changeParentAddress() {
      this.queryBtn_ok();
    },
    // 上级地区远程搜索
    remoteMethod(e) {
      let pN = "";
      if (!e) {
        // 默认
        pN = "中华人民共和国";
      }
      let p = {
        pageStart: 1,
        pageTotal: 100,
        districtName: e,
        parentName: pN,
      };
      this.$API.wtl_getDistrictList(p).then((res) => {
        this.SuperiorRegionList = res.data.result.data || [];
      });
    },
    // 弹窗上级地区远程搜索
    remoteMethod2(e) {
      let pN = "";
      let p = {
        pageStart: 1,
        pageTotal: 100,
        districtName: e,
        // parentName: pN,
      };
      this.$API.wtl_getDistrictList(p).then((res) => {
        this.SuperiorRegionList2 = res.data.result.data || [];
      });
    },
    // 默认查省级
    getParentName(e) {
      let p = {
        pageStart: 1,
        pageTotal: 100,
        parentName: e,
      };
      this.$API.wtl_getDistrictList(p).then((res) => {
        this.SuperiorRegionList = res.data.result.data || [];
      });
    },
    rowClickLeft(tree) {
      this.queryData.parentName = tree.districtName;
      this.queryData.parentId = tree.districtId;
      this.getData();
    },
    // 加载下一级
    loadMore(tree, treeNode, resolve) {
      let pid = tree.districtId || "";
      console.log("tree", tree);

      this.$API.wtl_getLeftDistrictList({ parentId: pid }).then((res) => {
        if (res.data.status == "success") {
          let bmList = res.data.result || [];
          bmList.forEach((item) => {
            item.children = [];
            item.hasChildren = true;
          });
          resolve(bmList);
        }
      });
      this.rowClickLeft(tree);
    },

    // 左边表格(获取最顶级(国家))
    departmentHierarchy(pid) {
      this.$API.wtl_getLeftDistrictList({ parentId: pid }).then((res) => {
        if (res.data.status == "success") {
          let bmList = res.data.result || [];
          bmList.forEach((item, index) => {
            item.children = [];
            item.hasChildren = true;
          });
          this.menuTableData = bmList;

          // this.menuTableData = this.diGuiGetMeun(bmList, "-1");
        }
      });
    },

    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    clerBtns() {
      //  重置按钮
      this.queryData = {
        districtName: "",
        parentName: "",
        parentId: "",
      };
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    // 启用
    qiYong(id, type) {
      let ids = [id]; //先清空之前的数据
      this.$confirm("是否启用所选地址", "提示:").then((res) => {
        this.$API.wtl_startDistrict({ districtIds: ids }).then((res) => {
          this.$message.success(res.data.message || "");
          this.getData();
        });
      });
    },
    // 禁用
    jinYong(id, type) {
      let ids = [id]; //先清空之前的数据
      this.$confirm("是否禁用所选地址", "提示:").then((res) => {
        this.$API.wtl_stopDistrict({ districtIds: ids }).then((res) => {
          this.$message.success(res.data.message || "");
          this.getData();
        });
      });
    },
    // 批量禁用
    jinYongMore() {
      let ids = []; //
      if (this.selectTableData.length < 1) {
        this.$message.warning("请选择需要禁用的地区");
        return false;
      }
      this.selectTableData.forEach((item) => {
        ids.push(item.districtId);
      });
      this.$confirm("是否禁用所选地区", "提示:").then((res) => {
        this.$API.wtl_stopDistrict({ districtIds: ids }).then((res) => {
          this.$message.success(res.data.message || "");
          this.getData();
        });
      });
    },
    // 批量启用
    qiYongMore() {
      let ids = []; //
      if (this.selectTableData.length < 1) {
        this.$message.warning("请选择需要启用的地区");
        return false;
      }
      this.selectTableData.forEach((item) => {
        ids.push(item.districtId);
      });
      this.$confirm("是否启用所选地区", "提示:").then((res) => {
        this.$API.wtl_startDistrict({ districtIds: ids }).then((res) => {
          this.$message.success(res.data.message || "");
          this.getData();
        });
      });
    },
    // 递归获取部门下所有id
    getDpIds(data) {
      let ids = this.deperIds || [];
      ids.push(data.departmentId);
      let arrs = data.children || [];
      for (var i = 0; i < arrs.length; i++) {
        ids.push(arrs[i].departmentId);
        let arr2 = arrs[i].children || [];
        for (var j = 0; j < arr2.length; j++) {
          this.getDpIds(arr2[j]);
        }
      }
      this.deperIds = ids;
      return this.deperIds;
    },

    //递归获取数据
    diGuiGetMeun(data, parentId) {
      let tree = [];
      let temp;
      data.forEach((item) => {
        if (item.parentId == parentId) {
          let obj = item;
          obj.departmentName = item.departmentName;
          obj.children = [];
          temp = this.diGuiGetMeun(data, item.departmentId);
          if (temp.length > 0) {
            obj.children = temp;
          }
          tree.push(obj);
        }
      });
      //排序
      for (var i = 0; i < tree.length - 1; i++) {
        for (var j = 0; j < tree.length - 1 - i; j++) {
          if (tree[j].sort > tree[j + 1].sort) {
            let temp = tree[j + 1];
            tree[j + 1] = tree[j];
            tree[j] = temp;
          }
        }
      }
      return tree;
    },
    //新建
    menuadd(row) {
      this.PopUpTitle = "新建地区";
      this.menushowBOX = true;
      this.dialogType = "add";
    },
    //修改
    menumodify(row, type) {
      this.$API
        .wtl_getDistrictDetail({ districtId: row.districtId })
        .then((res) => {
          // this.CalculationRules = res.data.result || {};
          let data = res.data.result || {};
          this.CalculationRules.districtId = data.districtId + "" || "";
          this.CalculationRules.parentId = data.parentId + "" || "";
          this.CalculationRules.parentName = data.parentName || "";
          this.CalculationRules.districtName = data.districtName || "";
          this.CalculationRules.adcode = data.adcode || "";
          this.CalculationRules.remarks = data.remarks || "";
          this.CalculationRules.isEnable = data.isEnable + "" || "0";
          this.CalculationRules.sort = data.sort || "1";

          console.log("CalculationRules");

          this.remoteMethod2(data.parentName);

          this.ClickLR = type;
          this.PopUpTitle = "修改地区";
          this.menushowBOX = true;
          this.dialogType = "edit";
        });
      //
      // if (data) {
      //   this.CalculationRules.districtId = data.districtId || "";
      //   this.CalculationRules.parentId = data.parentId || "";
      //   this.CalculationRules.districtName = data.districtName || "";
      //   this.CalculationRules.remarks = data.remarks || "";
      //   this.CalculationRules.isEnable = data.isEnable || "0";
      //   this.CalculationRules.sort = data.sort || "1";
      // }
    },
    // 删除
    delBtns(id, type) {
      let ids = [id];
      this.$confirm("是否删除该地区?", "提示:")
        .then(() => {
          this.$API.wtl_delDistrict({ districtIds: ids }).then((res) => {
            if (res.data.status == "success") {
              this.$message.success(res.data.message || "操作成功");
              if (type == "left") {
                this.reload();
              }
              this.getData();
            }
          });
        })
        .catch(() => {});
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.menushowBOX = false;
      this.CalculationRules = {
        districtName: "",
        adcode: "",
        parentId: "", //
        isEnable: "0", //
        sort: "1", //菜单排序
        remarks: "", //
      };
      this.getParentName("中华人民共和国"); //默认查到各省
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      this.$refs[formName].validate((valide) => {
        if (valide) {
          let param = {
            // districtId: this.CalculationRules.districtId || "",
            districtName: this.CalculationRules.districtName || "",
            adcode: this.CalculationRules.adcode || "",
            parentId: this.CalculationRules.parentId || "",
            isEnable: this.CalculationRules.isEnable || "0",
            remarks: this.CalculationRules.remarks || "",
            sort: this.CalculationRules.sort || "1",
          };
          if (this.dialogType == "add") {
            // 新建
            this.$API.wtl_addDistrict(param).then((res) => {
              this.$message.success(res.data.message || "success");
              this.menushowBOX = false;
              // 左边的刷新页面
              if (this.ClickLR == "left") {
                this.reload();
              } else {
                this.getData();
              }
            });
          } else {
            // 修改
            param.districtId = this.CalculationRules.districtId || "";

            this.$API.wtl_gudpateDistrict(param).then((res) => {
              this.$message.success(res.data.message || "success");
              this.menushowBOX = false;
              // 左边的刷新页面
              if (this.ClickLR == "left") {
                this.reload();
              } else {
                this.getData();
              }
            });
          }
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.menushowBOX = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },

    /**
     * =========================按钮部分的方法=>开始??????????????????????????????????
     */

    //导出操作
    handleCommand_dc(command) {
      if (command == "dc") {
        // 导出
        this.exportBtn();
      } else if (command == "dcmb") {
        // 下载模板
        this.exportTemplateDownload();
      } else if (command == "scmb") {
        // 上传模板
        this.upLoadBtn();
      }
    },

    // ===============================================导出部分=结束======

    /**
     * ******************************计算表格高度**开始*************************
     */
    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;

        this.leftHeight = windonHeight - 85;
        this.$refs.mytable.doLayout();
      });
    },
    /**
     * ******************************计算表格高度**结束*************************
     */

    // 获取自定义的排序,没有就用默认的
    getGroupFindFieldSort() {
      let that = this;
      this.$API
        .getGroupFindFieldSort({
          groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        })
        .then((res) => {
          let arr = res.data.result || [];
          if (arr.length > 0) {
            if (arr[0].sortObject) {
              that.myTableHeard = JSON.parse(arr[0].sortObject);
              this.sortName = arr[0].sortName;
            }
          } else {
            that.myTableHeard = that.tabelHeadeTitle;
          }
          let totalArr = [];
          //提取需要合计的字段
          for (var i = 0; i < that.myTableHeard.length; i++) {
            if (that.myTableHeard[i].isTotal) {
              totalArr.push(that.myTableHeard[i].field);
            }
          }
          that.totalArr = totalArr;
        });

      that.$nextTick(() => {
        that.$refs.mytable.doLayout();
      });
    },
    // 设置模板按钮
    myModel() {
      let that = this;
      that.show_sortTableHeard = true;
      that.tabelHeadeTitle = JSON.parse(JSON.stringify(that.myTableHeard));
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },

    // 排序==>取消按钮
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮
    confirmOk() {
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let signs = [
        {
          key: "sortName",
          val: this.sortName, //综合查询接口路径
        },
        {
          key: "groupName",
          val: this.pageGroupName,
        },
        {
          key: "sortObject",
          val: JSON.stringify(sortObject),
        },
      ];

      let sign = this.$TOOLS.getMD5Sign(signs);

      let param = {
        // apiPath: apiList.api_packageList, //综合查询接口路径
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
        sign: sign,
      };
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.getGroupFindFieldSort();
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    // 合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property == that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },

    //分页
    handleSizeChange(val) {
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageStart = val;
      this.getData();
    },
  },
};
</script>

<style scoped lang="less">
.box {
  width: 100%;
  display: flex;
}
.boxleft {
  // width: 40%;
  width: 380px;
  //   min-width: 390px;
  //   height: 88vh;
  overflow: auto;
  margin-right: 20px;
  // border: 1px solid #d7d7d7;
}
.boxright {
  // width: 70%;
  flex: 1;
  overflow: hidden;
  // height: 500px;
  // width: calc(100% - 430px);
}
.tablebut {
  margin-left: 15px;
}
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }
  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerbox {
  width: 100%;
  display: flex;
  justify-content: center;
}

.footerbox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.newForm {
  margin-left: 80px;
  .queryItem1 {
    width: 60%;
    margin-top: 20px;
    display: flex;
    .inputstyle {
      width: 100%;
      display: flex;
    }
  }
}

.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input,
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input__inner {
  width: 100%;
}

.frominput ::v-deep {
  .el-input__inner {
    height: 30px;
  }
}
</style>
